import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Player } from '@lottiefiles/react-lottie-player'
// import { useParams } from 'react-router-dom'
// import { startCheckingToken } from 'src/reducer/action/auth';
import { submitDatosAcceso } from 'src/reducer/action/pago'

// ima json
import canceled from 'src/assets/json/canceled.json'
import succesfull from 'src/assets/json/succesfull.json'
import expired from 'src/assets/json/expired.json'

import { getDetallePago } from 'src/service/APIService'
import { Alert } from 'react-bootstrap'
// import { useMediaQuery } from 'react-responsive'
import Icofont from 'react-icofont'
import { YappyEsperaConfirmacion } from './YappyEsperaConfirmacion'
import { getItemStepz } from 'src/helpers/localstorage'
// import { DotLottieReact } from '@lottiefiles/dotlottie-react'
// import security from 'src/assets/lottie/security.lottie'
import { ClaveEsperaConfirmacion } from './ClaveEsperaConfirmacion'

const ConfirmacionPago = ({ step, stepBackwards }) => {
  const dispatch = useDispatch()
  const { completado } = useSelector(state => state.ui)

  // loading state
  const [loading, setLoading] = useState(false)
  const [numeroRecibo, setNumeroRecibo] = useState(0)
  const [nombreCliente, setNombreCliente] = useState('')
  const [formaPago, setFormaPago] = useState('')
  const [monto, setMonto] = useState(0)
  const [fechaRecibo, setFechaRecibo] = useState('')
  const [polizaPagadas, setpolizaPagadas] = useState([])
  const [cantidadAplicado, setCantidadAplicado] = useState(0)
  // const isMobile = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    if (completado === 'E') {
      setTimeout(() => {
        window.location.reload()
        // dispatch(startCheckingToken(token, idacceso));
      }, 10000)
    }

    if (completado === 'S') {
      setLoading(true)
      getDetallePago().then(data => {
        if (!data.error) {
          const {
            NUMERORECIBO,
            NOMBRECLIENTE,
            FORMAPAGO,
            MONTOPAGADO,
            FECHARECIBO
          } = data.transaccion
          setNumeroRecibo(NUMERORECIBO)
          setNombreCliente(NOMBRECLIENTE)
          setFormaPago(FORMAPAGO)
          setMonto(MONTOPAGADO)
          setFechaRecibo(FECHARECIBO)
          setpolizaPagadas(data.polizasPagadas)
        }
        setLoading(false)
      })
    }

    if (completado === 'N') {
      setLoading(true)
      getDetallePago().then(data => {
        if (!data.error) {
          const {
            NUMERORECIBO,
            NOMBRECLIENTE,
            FORMAPAGO,
            MONTOPAGADO,
            FECHARECIBO,
            CANTIDADAPLICADO
          } = data.transaccion
          setNumeroRecibo(NUMERORECIBO)
          setNombreCliente(NOMBRECLIENTE)
          setFormaPago(FORMAPAGO)
          setMonto(MONTOPAGADO)
          setFechaRecibo(FECHARECIBO)
          setpolizaPagadas(data.polizasPagadas)
          setCantidadAplicado(CANTIDADAPLICADO)
        }
        setLoading(false)
      })
    }
  }, [completado])

  const goBackStep = () => {
    dispatch(
      submitDatosAcceso({
        idaccion: 3,
        completado: 'N'
      })
    )
    stepBackwards(step)

    if (parseFloat(getItemStepz()?.pay) === parseFloat(process.env.REACT_APP_ID_ORIGEN_CLAVE)) {
      stepBackwards(step)
    }
  }

  return (
    <div>
      <br />
      <br />
      {/* TRANSACCION COMPLETADA */}
      {completado === 'S' && (
        <>
          <Player
            autoplay
            loop
            src={succesfull}
            style={{ height: '180px', width: '200px' }}
          >
            {/* <Controls visible={true} buttons={['play', 'repeat', 'frame', 'debug']} /> */}
          </Player>
          <h5 className='fw-bold text-uppercase font-italic text-center'>
            Pago realizado
          </h5>
          <p className='fw-bold text-uppercase text-center'>
            Detalle de la transacción
          </p>
          <div className='table-responsive d-flex justify-content-center'>
            <table className='table table-xs w-50'>
              <thead>
                <tr>
                  {/* <td>NÚMERO DE RECIBO</td>
                  <td>MONTO</td>
                  <td>FECHA DE TRANSACCIÓN</td> */}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr scope>
                    <td colSpan={4}>loading...</td>
                    {/* <td>loading..</td>
                                                    <td>loading..</td> */}
                  </tr>
                ) : (
                  <>
                    <tr>
                      <td className='fw-bold' style={{ background: '#e4e4e4' }}>
                        Cliente
                      </td>
                      <td className='fw-bold' style={{ background: '#e4e4e4' }}>
                        {nombreCliente}
                      </td>
                    </tr>
                    <tr>
                      <td>Número de recibo</td>
                      <td>{numeroRecibo}</td>
                    </tr>
                    <tr>
                      <td>Forma de pago</td>
                      <td>{formaPago}</td>
                    </tr>
                    <tr>
                      <td>Fecha de la transacción</td>
                      <td>{fechaRecibo}</td>
                    </tr>
                    <tr>
                      <td className='fw-bold'>Total</td>
                      <td className='fw-bold'>${monto}</td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          <br />
          <p className='fw-bold text-uppercase text-center'>
            DETALLE DE LAS PÓLIZAS PAGADA
          </p>
          <div className='table-responsive d-flex justify-content-center'>
            <table className='table table-xs w-50'>
              <thead>
                <tr>
                  <th style={{ background: '#e4e4e4' }}>Póliza</th>
                  <th style={{ background: '#e4e4e4' }}>Descripción</th>
                  <th style={{ background: '#e4e4e4' }}>Monto Pagado</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr scope>
                    <td colSpan={4}>loading...</td>
                    {/* <td>loading..</td>
                                                      <td>loading..</td> */}
                  </tr>
                ) : (
                  polizaPagadas.map(
                    (
                      { POLIZA, DESCRIPCION, DESCRIPCIONRAMO, MONTO },
                      index
                    ) => (
                      <tr key={index}>
                        <td>{POLIZA}</td>
                        <td>{`${DESCRIPCION} ${DESCRIPCIONRAMO}`}</td>
                        <td>${MONTO}</td>
                      </tr>
                    )
                  )
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td></td>
                  <td className='text-right fw-bold'>${monto || '-'}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <p className='text-center' style={{ fontSize: '14px' }}>
            Para mayor información o consulta , contactenos a  <a href="mailto:pagos@segfedpa.com">pagos@segfedpa.com</a>
          </p>
          <p
            className='text-center text-muted'
            style={{ fontSize: '12px', margin: '4px' }}
          >
            ** En un plazo máximo de 24 horas su saldo estará actualizado.
          </p>

          <p className='text-center text-muted' style={{ fontSize: '12px' }}>
            ** Se envió un comprobante de pago al correo electrónico
            proporcionado
            <br />
            Por favor revise su bandeja de entrada o la bandeja de correo no
            deseado
          </p>
        </>
      )}

      {/* EN ESPERA DE RESPUESTA DE LA TRANSACCION */}
      {completado === 'E' && (
        <>
          {parseFloat(getItemStepz()?.pay) === parseFloat(process.env.REACT_APP_ID_ORIGEN_YAPPY) ? (
            <YappyEsperaConfirmacion />
          ) : parseFloat(getItemStepz()?.pay) === parseFloat(process.env.REACT_APP_ID_ORIGEN_CLAVE) ? (
            <ClaveEsperaConfirmacion />
          ) : (
            <div className="text-center">
              <p>Procesando transacción...</p>
            </div>
          )}
        </>
      )}

      {/* TRANSACCION RECHAZADA */}
      {(completado === 'R' || completado === 'C') && (
        <div className='text-center'>
          <br />
          <Player
            autoplay
            stop
            loop
            src={canceled}
            style={{ height: '100px', width: '100px' }}
          >
            {/* <Controls visible={true} buttons={['play', 'repeat', 'frame', 'debug']} /> */}
          </Player>
          <br />
          <h5 className='fw-bold text-danger'>Pago rechazado</h5>
          <p className='form-text'>
            El proceso de pago no pudo finalizar correctamente.
            <br />
            Si lo deseas, puedes intentarlo nuevamente.
          </p>
          <div className='d-flex justify-content-center'></div>
          <br />
          <button className='btn-pay' onClick={goBackStep}>
            <Icofont icon='arrow-left' />
            Volver
          </button>
        </div>
      )}

      {/* TRANSACCION EXPIRADO */}
      {completado === 'X' && (
        <div className='text-center'>
          <br />
          <Player
            autoplay
            stop
            loop
            src={expired}
            style={{ height: '100px', width: '100px' }}
          >
            {/* <Controls visible={true} buttons={['play', 'repeat', 'frame', 'debug']} /> */}
          </Player>
          <br />
          <h5 className='fw-bold text-secondary'>Solicitud expirada</h5>
          <p className='form-text'>El tiempo para completar el pago ha finalizado.<br /> Puedes intentarlo nuevamente.</p>
          <div className='d-flex justify-content-center'></div>
          <br />
          <button className='btn-pay' onClick={goBackStep}>
            <Icofont icon='arrow-left' />
            Volver
          </button>
        </div>
      )}

      {/* TRANSACCION NO COMPLETADO */}
      {completado === 'N' && cantidadAplicado > 0 && (
        <div className='text-center'>
          <br />
          <Alert variant="warning">
            <Alert.Heading className="fw-bold">Pago no aplicado correctamente</Alert.Heading>
            <p className='fw-bold'>Número de recibo: {numeroRecibo}</p>
            <p>
              Por favor, contáctenos a <a href="mailto:pagos@segfedpa.com">pagos@segfedpa.com</a> con el número de recibo generado para completar el pago en nuestro sistema.
            </p>
          </Alert>
        </div>
      )}
      <br />
    </div>
  )
}

export default ConfirmacionPago
